import { useCallback, useState } from 'react';

export const useTokenBasedPaging = () => {
  const [tokensStack, setTokensStack] = useState<string[]>([]);
  const currentPageToken = tokensStack[tokensStack.length - 1] ?? '';

  const onNextPage = useCallback(
    (nextPageToken?: string) =>
      nextPageToken && setTokensStack((prev) => [...prev, nextPageToken]),
    [],
  );
  const onPrevPage = useCallback(
    () => setTokensStack((prev) => prev.slice(0, -1)),
    [],
  );
  const onFirstPage = useCallback(() => setTokensStack([]), []);

  return {
    currentPageToken,
    onNextPage,
    onPrevPage,
    onFirstPage,
  };
};
